<template>
    <div class="gofixCard" v-bind:class="{gofixCardNoTitle:!title,gofixCardFullContent:fullContent,gofixCardCollapse:collapse}">
        <slot name="gofixCard:before_card"></slot>
        <div class="gofixCardHeader" :class="classHeader" v-if="title">
            <h3 class="title" @click.stop="changeCollapseStatus">
                <slot name="gofixCard:before_title"></slot>
                <span class="collapse-icon" v-if="collapse" v-bind:class="{closeContent: !collapseStatus}"></span>
                {{title}}
                <slot name="gofixCard:after_title"></slot>
            </h3>
            <div class="rightHeader" v-show="collapseStatus">
                <slot name="gofixCard:right_header"></slot>
            </div>
        </div>
        <transition>
            <div class="gofixCardContent" :class="classContent" v-show="collapseStatus">
                <slot name="gofixCard:before_card_content"></slot>
                <slot></slot>
                <slot name="gofixCard:after_card_content"></slot>
            </div>
        </transition>

        <slot name="gofixCard:after_card"></slot>
    </div>
</template>

<script>
    export default {
        name: "gofix-card",
        props: {
            title: {
                type: String,
                required: false,
                default: () => null
            },
            fullContent: {
                type: Boolean,
                required: false,
                default: () => false
            },
            collapse: {
                type: Boolean,
                required: false,
                default: () => false
            },
            classHeader: {
                type: String,
                required: false,
                default: () => null
            },
            classContent: {
                type: String,
                required: false,
                default: () => null
            },
            isShowCollapse: {
                type: Boolean,
                required: false,
                default: () => true
            },
        },
        data() {
            return {
                collapseStatus : this.isShowCollapse
            }
        },
        methods: {
            changeCollapseStatus(){
                if(this.collapse){
                    this.collapseStatus = !this.collapseStatus;
                }
            }
        }
    }
</script>

<style scoped>

</style>
